// Live headcounts for the rooms that are always open, on the situation pages.
//
// The page is complete without this: the spans are hidden until a count
// arrives, so a visitor with scripts blocked, or a server without the
// endpoint, sees a page that simply does not mention numbers. GET
// /api/rooms/standing is public and answers for the ADULT band only (teens
// are never counted publicly), cached thirty seconds server-side. The page's
// stylesheet comes from its own <link>, not from here. ASCII only.

const spans = document.querySelectorAll('[data-standing]');

if (spans.length) {
  fetch('/api/rooms/standing', { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null))
    .then((body) => {
      // The endpoint answers with an envelope, { rooms: [...] }, not a bare
      // array -- ui/room-counts.js reads it the same way. Unwrapping it
      // wrongly here failed silently, which is exactly how a page ends up
      // quietly never showing a number nobody notices is missing.
      const rows = Array.isArray(body?.rooms) ? body.rooms : null;
      if (!rows) return;
      const bySlug = new Map(rows.map((row) => [row.slug, row]));
      for (const span of spans) {
        const row = bySlug.get(span.dataset.standing);
        if (!row || typeof row.members !== 'number') continue;
        // "here now" rather than "online": it is the room's headcount at this
        // moment, and nothing else about anyone.
        span.textContent = row.members === 1 ? '1 person here now' : `${row.members} people here now`;
        span.hidden = false;
      }
    })
    .catch(() => {
      // Silence is the honest fallback; a wrong number is worse than none.
    });
}
